import * as React from "react";
import { toast as sonnerToast } from "sonner";

import { AlertBanner } from "@/components/ui/alert-banner";

type ToastId = string | number;

type Variant = "default" | "success" | "destructive" | "warning" | "info";

type ToastOptions = {
  description?: React.ReactNode;
  duration?: number;
  style?: React.CSSProperties;
};

function show(variant: Variant, title: string, options?: ToastOptions) {
  return sonnerToast.custom(
    (t) =>
      React.createElement(
        "div",
        { className: "w-full max-w-[420px]", style: options?.style },
        React.createElement(AlertBanner, {
          variant,
          title,
          description: options?.description,
          onDismiss: () => sonnerToast.dismiss(t),
        }),
      ),
    {
      duration: options?.duration,
    },
  );
}

function loading(title: string, options?: ToastOptions): ToastId {
  return sonnerToast.custom(
    (t) =>
      React.createElement(
        "div",
        { className: "w-full max-w-[420px]", style: options?.style },
        React.createElement(AlertBanner, {
          variant: "info",
          title,
          description: options?.description,
          onDismiss: () => sonnerToast.dismiss(t),
        }),
      ),
    {
      duration: options?.duration ?? 1000000,
    },
  );
}

export const toast = {
  success: (title: string, options?: ToastOptions) =>
    show("success", title, options),
  error: (title: string, options?: ToastOptions) =>
    show("destructive", title, options),
  warning: (title: string, options?: ToastOptions) =>
    show("warning", title, options),
  info: (title: string, options?: ToastOptions) => show("info", title, options),
  loading,
  dismiss: (toastId?: ToastId) => sonnerToast.dismiss(toastId),
};
